import { Language } from './enums'

/*declare global {
    interface Window {
        grecaptcha: any
        captchaOnLoad: () => void
    }
}

type Captcha = {
    chinese: boolean
    lang: Language | undefined
    script: HTMLScriptElement | undefined
    holder: HTMLDivElement | undefined
    badge: 'bottomleft' | 'bottomright'
    init?: Promise<boolean>
    id?: number
    resolve?: (value: boolean) => void
}


const captcha: Captcha = {
    chinese: false,
    lang: undefined,
    script: undefined,
    holder: undefined,
    badge: 'bottomright'
}


 window.captchaOnLoad = async () => {
    await appInit
    captcha.holder = document.body.appendChild(document.createElement('div'))
    const id = window.grecaptcha.render(captcha.holder, {
        sitekey: appConfig.REACT_APP_RECAPTCHA_SITE_KEY_V3,
        size: 'invisible',
        badge: captcha.badge
    })
    captcha.id = id
    captcha.resolve && captcha.resolve(true)
}
 */
const initCaptcha = async (language: Language, countryCode?: string) => {
/*     const isChineseUser = countryCode === 'CHN' ||
        ((language === 'zh' || language === 'zh-Hans' || language === 'zh-Hant') &&
            countryCode === 'SYC')
    if (isChineseUser !== captcha.chinese || language !== captcha.lang) {
        captcha.init = new Promise(r => captcha.resolve = r)
        removeCaptcha()
        captcha.chinese = isChineseUser
        captcha.lang = language
        captcha.badge = language === 'ar' ? 'bottomleft' : 'bottomright'
        const script = document.createElement('script')
        script.async = true
        script.defer = true
        script.src = `https://www.${isChineseUser ? 'recaptcha.net' : 'google.com'}/recaptcha/api.js?render=explicit&hl=${language}&onload=captchaOnLoad`
        script.type = 'text/javascript'
        captcha.script = document.body.appendChild(script)
    }
 */}

/* const removeCaptcha = () => {
     const db = document.body
    if (captcha.script &&
        db.contains(captcha.script))
        db.removeChild(captcha.script)
    if (captcha.holder &&
        db.contains(captcha.holder)) {
        captcha.holder.innerHTML = ''
        db.removeChild(captcha.holder)
    }
}
 */
const useReCaptcha = () => {
    // const { t } = useTranslation()
    // const notReady = t('account:login.captchaNotReady')
    // const execError = 'captcha execute error'
    return {
        initCaptcha,
        executeCaptcha: async (): Promise<string> => {
            return Promise.resolve('disabled')
/*             await captcha.init
            if (!window.grecaptcha) throw (new Error(notReady))
            let token = await window.grecaptcha.execute(captcha.id)
            if (!token) throw (new Error(execError))
            return token
 */        }
    }
}

export { useReCaptcha }

